module.exports = __webpack_public_path__ + "img/Le_Figaro.242acc7a.svg";